var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeItUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44448 19.9993C8.34454 19.999 8.24762 19.965 8.16935 19.9029C8.08835 19.8391 8.03206 19.749 8.01011 19.6483C7.98816 19.5475 8.00192 19.4423 8.04902 19.3505L11.1452 13.332H5.77828C5.68763 13.3321 5.59912 13.3045 5.52465 13.2528C5.45018 13.2011 5.39332 13.1278 5.36171 13.0428C5.32985 12.9577 5.32484 12.8648 5.34736 12.7768C5.36988 12.6887 5.41885 12.6097 5.48767 12.5503L15.2687 4.10625C15.3486 4.03813 15.45 4.00049 15.555 4C15.6546 3.9999 15.7513 4.03337 15.8295 4.09499C15.9106 4.15886 15.9671 4.24894 15.9892 4.34983C16.0112 4.45073 15.9976 4.55615 15.9505 4.64808L12.8544 10.6665H18.2219C18.3126 10.6665 18.4011 10.6941 18.4756 10.7458C18.55 10.7975 18.6069 10.8708 18.6385 10.9558C18.6705 11.0409 18.6755 11.1338 18.653 11.2219C18.6305 11.3099 18.5815 11.389 18.5126 11.4483L8.7358 19.8923C8.655 19.962 8.55184 20.0002 8.44518 20",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeItUp);
export default __webpack_public_path__ + "static/media/ChargeItUp.374666f007ad81709b04c74a167cee66.svg";
export { ForwardRef as ReactComponent };